import BaseComponent from "../mx/BaseComponent";
export default BaseComponent;
